var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"16","cy":"16","r":"16","fill":"#6677FB","key":0}),React.createElement("path",{"d":"M23 11.85a5.805 5.805 0 0 1-1.65.454 2.883 2.883 0 0 0 1.264-1.59c-.555.329-1.169.57-1.824.697a2.873 2.873 0 0 0-4.895 2.62 8.14 8.14 0 0 1-5.922-3.006 2.878 2.878 0 0 0 .89 3.84 2.802 2.802 0 0 1-1.302-.359v.036c0 1.394.99 2.555 2.305 2.819-.24.065-.496.1-.757.1a2.71 2.71 0 0 1-.54-.053 2.877 2.877 0 0 0 2.685 1.997A5.758 5.758 0 0 1 9 20.595c1.27.825 2.78 1.3 4.4 1.3 5.286 0 8.176-4.383 8.176-8.184 0-.125-.003-.25-.009-.371A5.898 5.898 0 0 0 23 11.85Z","fill":"#fff","key":1})]);
}

Twitter.defaultProps = {"width":"32","height":"32","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
